<template>
  <div class="add-bank-list">
    <div class="left">
      <div class="left-top">
        <img src="@/assets/style/add-card-logo.png" alt="" />
        <span>中国建设银行</span>
      </div>
      <div class="left-bottom">2312 **** **** 2312</div>
    </div>
    <div class="right-set">
     <input type="checkbox" />
    </div>
  </div>
</template>

<script>
export default {
  name: "addBankList",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.add-bank-list {
  height: 80px;
  background: #0f7ccd;
  border-radius: 8px;
  padding: 19px 16px 16px 16px;
  background-image: url("@/assets/style/card-list-bg.png");
  background-size: 145px 145px;
  background-repeat: no-repeat;
  background-position: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;
  color: #fff;
}
.left {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  .left-top {
    display: flex;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
      margin-right: 4px;
    }
  }
  .left-bottom {
    font-size: 18px;
    color: #fff;
  }
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #fff;
  margin-right: 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0f7ccd;
  flex-shrink: 0;

  &:checked {
    background-color: #fff;
    &::after {
      content: "";
      width: 8px;
      height: 4px;
      border: 2px solid #01a0e5;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
      margin-top: -2px;
    }
  }
}
</style>
